import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { T } from '../../../../../../Translations';
import { LearningCollectionProvider, useLearningCollection } from '../LearningCollectionContext';
import ReadyBuilder from '../ReadyBuilder';
import { LearningCollectionResource } from '../Types';
import AddSectionSkeleton from './AddSectionSkeleton';
import { useBuilder } from './useBuilder';
import { useFilterOptions } from '../Filters/useFilterOptions';
import { persistentFilterStore } from '../Filters/PersistentFilterStore';

// Inner component to use the context
function NewBuilderContent({ resource }: { resource: LearningCollectionResource }) {
  const { setResourceState } = useLearningCollection();

  // Initiate filter options query - will be cached for 15 minutes
  useFilterOptions(resource.links);

  useEffect(() => {
    // Override the default collection name from backend with our custom default
    const resourceWithCustomName = {
      ...resource,
      payload: {
        ...resource.payload,
        name: 'Name your collection 🚀',
      },
    };
    setResourceState(resourceWithCustomName);
  }, [resource, setResourceState]);

  return <ReadyBuilder stateKind="new" />;
}

function Builder() {
  const { newLearningCollectionState } = useBuilder();

  // Clear persistent filter store when the Builder unmounts (leaving the editor)
  useEffect(() => {
    return () => {
      persistentFilterStore.clear();
    };
  }, []);

  switch (newLearningCollectionState.kind) {
    case 'loading':
      return <AddSectionSkeleton />;
    case 'errored':
      return <T kind="oops learning collection failed!" />;
    case 'ready':
      return (
        <LearningCollectionProvider>
          <NewBuilderContent resource={newLearningCollectionState.data.resource} />
        </LearningCollectionProvider>
      );
  }
}

export default observer(Builder);
